<template>
  <div>
    <BaseFrame
      saveText='保存' 
      :logText="$route.params.id ? '操作日志' : ''"
      :infosArr='titleInfo'
      :idText='idText'
      :id='id'
      :able='able'
      @save='handleSave'
      @hanldeLog='getRecord'
      @clear="clearAll"
      :logData='records'
    >
      <div slot="content" >
          <div class='cardContainer'>
            <lk-card title='基础商品信息'>
              <lk-form  :label-width='134' label-position="right">
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label="商品类型:" prop='typeId' class='ivu-form-item-required'>
                      <goodsTypeCascader v-if="able" v-model='typeId' @on-change='handleType' placeholder="请选择，一旦保存将无法修改" :disabled='editDisabled'></goodsTypeCascader>
                      <span v-else>{{typeName}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
            </lk-card>
          </div>
        <div >
          <div v-if='ready'>
            <Drug v-if='goodsType===1' v-model="info.goodsBase" :able='able' :baseData='baseData' :isFromBaseInfo='true' @handleExist='handleExist' ref="baseInfo"></Drug>
            <Equipment v-if='goodsType===2' v-model="info.goodsBase" :able='able' :baseData='baseData' :isFromBaseInfo='true' @handleExist='handleExist' ref="baseInfo"></Equipment>
            <Decoction v-if='goodsType===3' v-model="info.goodsBase" :able='able' :baseData='baseData' :isFromBaseInfo='true' @handleExist='handleExist' ref="baseInfo"></Decoction>
            <Cso v-if='goodsType===13' v-model="info.goodsBase" :able='able' :baseData='baseData' @handleExist='handleExist' ref="baseInfo"></Cso>
            <Others v-if="![1,2,3,13].includes(goodsType)" :type='goodsType' v-model="info.goodsBase" :able='able' :baseData='baseData' @handleExist='handleExist' ref="baseInfo" isFromBaseInfo='{goodsType==6}' :requiredPeriodProdLicense='false'></Others>
          </div>
        </div>
      </div>
    </BaseFrame>
     <DTPModal v-model.trim="existsModal" :content='existsContent' @confirm='inExistsConfirm'
          @handleCancel='inExistsCancel' confirmText='编辑' type='alert'></DTPModal>
        <DTPModal v-model.trim="clearModal" content='重置将取消当前所做更改。' @confirm='reset' type='alert'></DTPModal>
<DTPModal v-model.trim="typeModal" @handleCancel='typeId=goodsType' content='切换商品类型将清空商品信息，是否确认此操作？' @confirm='confirmChangeType'></DTPModal>
  </div>
</template>

<script>
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import Drug from '../../../components/goods/baseGoods/Drug.vue';
import Decoction from '../../../components/goods/baseGoods/Decoction.vue';
import Equipment from '../../../components/goods/baseGoods/Equipment.vue';
import Cso from '../../../components/goods/baseGoods/Cso.vue';
import Others from '../../../components/goods/baseGoods/Others.vue';
import goodsTypeCascader from '../../../components/goodsTypeCascader.vue';
import DTPModal from '../../../components/DTPModal.vue';
import goods from '../../../services/goods';
import utils from '../../../libs/utils';
import goodsMixins from '../../../mixins/goodsMixins';


export default {
  name: 'GoodsBase',
  mixins: [goodsMixins],
  components: {
    BaseFrame,
    Equipment,
    Drug,
    Others,
    Cso,
    Decoction,
    DTPModal,
    goodsTypeCascader,
  },
  watch: {
    info: {
      handler() {
        setTimeout(() => {
          this.canWatch = this.ready;// 处理数据载入watch问题
        }, 100);
        this.canWatch && this.$store.commit('setLeaveModal', true);
      },
      deep: true,
    },
    $route() {
      this.init(1);
    },
  },
  computed: {
    existsContent() {
      let message = '';
      if (this.info.goodsBase) {
        message = `批准文号:${this.info.goodsBase.approvalNumber} 规格:${this.info.goodsBase.specifications} 此商品信息已存在，是否去编辑？`;
      }
      return message;
    },
  },
  data() {
    return {
      inited: false,
      canWatch: false,
      goodsType: null,
      typeModal: false,
      records: [],
      exsitId: '',
      editDisabled: false,
      idText: '',
      id: '',
      titleInfo: [],
      clearModal: false,
      existsModal: false,
      typeId: null,
      ready: false,
      able: true,
      info: {},
      baseData: {
        dosageFormArr: [],
        drugMiniPackageUnitArr: [],
        storageConditionsArr: [],
        qualityOfDrugsTypeArr: [],
        preparationUnitArr: [],
        decoctionBucketArr: [],
        approvalNumberTypeArr: [],
        frequencyArr: [],
        usageArr: [],
        indicationTree: null,
        label: {
          gspArr: [],
          bizArr: [],
          prodArr: [],
          otherArr: [],
        },
      },
    };
  },
  methods: {
    clearAll() {
      this.clearModal = true;
    },
    handleType() {
      this.canWatch = false;
      this.typeModal = true;
    },
    confirmChangeType() {
      this.init(this.typeId);
      this.typeModal = false;
    },
    reset() {
      if (this.$route.params.id) {
        this.init(this.typeId);
      } else {
        this.info = {
          goodsBase: {
            isImport: 2,
          },
        };
      }
      setTimeout(() => {
        this.$store.commit('setLeaveModal', false);
      }, 200);
      this.clearModal = false;
    },
    inExistsConfirm() {
      this.existsModal = false;
      this.$store.commit('setLeaveModal', false);
      this.$nextTick(() => {
        this.$router.push({ name: 'goodsBaseEdit', params: { id: this.exsitId, type: this.typeId } });
      });
    },
    inExistsCancel() {
      this.existsModal = false;
      this.reset();
    },
    handleExist(params) {
      params.type = this.typeId;
      this.$store.commit('setDisableLoading', true);
      goods.existsGoodsBase(params).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data && res.data.data > 0) {
            if (this.$route.params.id * 1 !== res.data.data) {
              this.existsModal = true;
              this.exsitId = res.data.data;
            }
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getSelectArrs() {
      return new Promise((resolve) => {
        this.baseData.decoctionBucketArr = [];
        this.baseData.drugMiniPackageUnitArr = [];
        this.baseData.storageConditionsArr = [];
        this.baseData.qualityOfDrugsTypeArr = [];
        this.baseData.dosageFormArr = [];
        this.baseData.preparationUnitArr = [];
        this.baseData.frequencyArr = [];
        this.baseData.usageArr = [];
        this.baseData.approvalNumberTypeArr = this.approvalNumberTypeArr;
        goods.GoodsDictionary().then((res) => {
          if (res.data.status === 200) {
            res.data.data.forEach((item) => {
              switch (item.dictionaryType) {
                case 1:
                  this.baseData.dosageFormArr.push(item);
                  break;
                case 2:
                  this.baseData.decoctionBucketArr.push(item);
                  break;
                case 3:
                  this.baseData.drugMiniPackageUnitArr.push(item);
                  break;
                case 8:
                  this.baseData.qualityOfDrugsTypeArr.push(item);
                  break;
                case 9:
                  this.baseData.storageConditionsArr.push(item);
                  break;
                case 11:
                  this.baseData.preparationUnitArr.push(item);
                  break;
                case 14:
                  this.baseData.usageArr.push(item);
                  break;
                case 15:
                  this.baseData.frequencyArr.push(item);
                  break;
                default:
                  break;
              }
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    formatLabel(data, setData) {
      if (setData) {
        data.goodsBase.gspIdList = data.gspIdList;
        data.goodsBase.bizIdList = data.bizIdList;
        data.goodsBase.prodIdList = data.prodIdList;
        data.goodsBase.otherIdList = data.otherIdList;
        data.goodsBase.gsps = data.gsps;
        data.goodsBase.bizs = data.bizs;
        data.goodsBase.prods = data.prods;
        data.goodsBase.others = data.others;
        if (data.goodsBase.minTemp === '') {
          data.goodsBase.minTemp = null;
        }
        if (data.goodsBase.maxTemp === '') {
          data.goodsBase.maxTemp = null;
        }
        data.goodsBase.storageConditionsStringNew = data.storageConditionsString;
        data.goodsBase.drugMiniPackageUnitString = data.drugMiniPackageUnitString;
        data.goodsBase.indicationDicString = data.indicationDicString;
        data.goodsBase.dosageFormString = data.dosageFormString;
        data.goodsBase.preparationUnitString = data.preparationUnitString;
      } else {
        data.gspIdList = data.goodsBase.gspIdList;
        data.bizIdList = data.goodsBase.bizIdList;
        data.prodIdList = data.goodsBase.prodIdList;
        data.otherIdList = data.goodsBase.otherIdList;
      }
    },
    getRecord() {
      this.$store.commit('setDisableLoading', true);
      goods.getBaseRecord({ id: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          this.records = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      goods.getGoodsBaseById({ id: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          if (this.typeId === 1) {
            const { result, typeStr } = this.handleGoodsApprovalType(this.approvalNumberTypeArr, data.goodsBase.approvalNumber);
            data.goodsBase.approvalNumber = result;
            data.goodsBase.approvalNumberType = typeStr;
          }
          this.formatLabel(data, true);
          console.log(data.goodsBase.minTemp, 12313132132);
          if (data.goodsBase.minTemp != '' && data.goodsBase.minTemp != null) {
            data.goodsBase.minTemp *= 1;
          }
          if (data.goodsBase.maxTemp != '' && data.goodsBase.maxTemp != null) {
            data.goodsBase.maxTemp *= 1;
          }
          this.typeId = data.goodsBase.type;
          this.info = data;
          this.idText = '商品ID';
          this.id = data.goodsBase.drugSerialCode;
          this.titleInfo = [
            { name: '商品通用名：', value: data.goodsBase.approvedDrugNames },
            { name: '创建人：', value: data.goodsBase.createUserName },
            { name: '创建时间：', value: data.goodsBase.createTime ? utils.exchangeTimeToSecond(data.goodsBase.createTime) : '' },
            { name: '最后修改人：', value: data.goodsBase.modifiedUserName },
            { name: '最后修改时间：', value: data.goodsBase.modifiedTime ? utils.exchangeTimeToSecond(data.goodsBase.modifiedTime) : '' },
          ];
          this.ready = true;
          setTimeout(() => {
            this.$store.commit('setLeaveModal', false);
          }, 200);
        } else {
          this.$Message.error(res.data.error);
        }
      });
    },
    handleSave() {
      const saveFunc = this.$route.params.id ? goods.updateGoodsBase : goods.createGoodsBase;
      this.$refs.baseInfo.validateForm().then((valid) => {
        if (valid && utils.handleExpire(this.$refs.baseInfo.$el)) {
          const temp = utils.deepClone(this.info);
          temp.goodsBase.type = this.typeId;

          delete temp.goodsLabelList;
          delete temp.goodsLabelIdList;
          if (temp.goodsBase.storageConditions != 6) {
            temp.goodsBase.otherStorageCondition = '';
          }
          if (temp.goodsBase.approvalNumberType) {
            temp.goodsBase.approvalNumber = temp.goodsBase.approvalNumberType + temp.goodsBase.approvalNumber;
            delete temp.goodsBase.approvalNumberType;
          }
          if (Array.isArray(temp.goodsBase.sampleType)) {
            temp.goodsBase.sampleType = temp.goodsBase.sampleType.slice(-1)[0];
          }
          this.formatLabel(temp);
          saveFunc(temp).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('保存成功');
              this.$store.commit('setLeaveModal', false);

              this.$router.push({ name: 'goodsBaseList', params: { create: !this.$route.params.id } });
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        } else {
          this.$Message.error('缺少必填项或信息不符合要求，请检查后再提交');
        }
      });
    },
    init(type) {
      console.log(this.$route.params);
      this.canWatch = false;
      this.ready = false;
      Promise.all([
        this.getAllLabels(this.$route.params.type || type),
        this.getSelectArrs(),
        this.fetchListIndications(),
      ]).then(() => {
        this.able = this.$route.name !== 'goodsBaseView';
        this.$nextTick(() => {
          this.typeId = (this.$route.params.type * 1) || type;
          this.goodsType = this.typeId;
          if (this.$route.params.id) {
            this.getData();
            this.editDisabled = true;
          } else {
            this.ready = true;
            this.reset();
          }
        });
      });
    },
  },
  mounted() {
    this.init(1);
  },
};
</script>

<style scoped>
  .cardContainer{
    margin-bottom: 16px
  }
  .storageConditions{
    display: flex;
    align-items: center;
    justify-content: space-between

  }
  .other{
    /* width: 17% */
  }
  .temperature{
    width:660px;
    display: flex;
    justify-content: flex-end
  }
</style>
